import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Palette } from "lucide-react";
import { brand } from "@/lib/api";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/gallery", label: "Gallery" },
  { to: "/about", label: "About Tay" },
  { to: "/faqs", label: "FAQs" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-cream border-b-[3px] border-ink" data-testid="navbar">
      <nav className="section flex items-center justify-between py-3">
        <Link to="/" className="flex items-center gap-2 shrink-0" data-testid="nav-logo" onClick={() => setOpen(false)}>
          <img src={brand.logo} alt="Paint With Tay — Face Painting & Creative Events" className="h-14 sm:h-16 w-auto" data-testid="brand-logo" />
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `font-heading font-500 px-3 py-2 rounded-full transition-colors ${
                  isActive ? "text-hotpink" : "text-ink hover:text-purple"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <Link to="/book" className="btn-pink ml-2 !py-2.5 !px-6" data-testid="nav-book-now">
            <Palette className="w-5 h-5" /> Book Now
          </Link>
        </div>

        <div className="flex items-center gap-2 lg:hidden">
          <Link to="/book" className="btn-pink !py-2 !px-4 text-sm" data-testid="nav-book-now-mobile">
            Book Now
          </Link>
          <button
            aria-label="Toggle menu"
            onClick={() => setOpen((o) => !o)}
            className="p-2 rounded-xl border-[2.5px] border-ink bg-white"
            data-testid="nav-menu-toggle"
          >
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden bg-cream border-t-[3px] border-ink" data-testid="mobile-menu">
          <div className="section py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-heading text-lg py-2.5 px-3 rounded-xl ${
                    isActive ? "bg-sunshine text-ink" : "text-ink"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
